module.exports = __webpack_public_path__ + "static/img/8.8b1165e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/8.png
// module id = qpE3
// module chunks = 35